<template>
  <div class="con-upload">
    <view-upload
      v-if="viewActive"
      :src="viewSrc"
      style="z-index: 1000000"
    />
    
    <vs-row v-if="viewUploadx && multiple === true && limit !== 500 && !isInternalChatMessage && !isIosDevice">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
        <div v-if="activeImageIndex.active" class="vs-upload--img-src">
            <img
              :src="itemsLoaded[getFilesPreview].url"
              style="width: 300px; 
                     height: 300px; 
                     object-fit: cover;"
              :alt="itemsLoaded[getFilesPreview].name"
              @touchend="viewImage(itemsLoaded[getFilesPreview].url, $event)"
              @dblclick="viewImage(itemsLoaded[getFilesPreview].url, $event)"
            >
            <h4
              v-if="!itemsLoaded[getFilesPreview].url"
              class="text-archive">
              <i
                translate="no"
                class="material-icons notranslate">
                description
              </i>
              <span>
                {{ itemsLoaded[getFilesPreview].name }}
              </span>
            </h4>
        </div>
        <div v-else>
          <p 
            style="text-align: center; 
                   font-size: 1.2rem; 
                   margin-top: 2rem;"
            >Clique no upload para escolher uma prévia da imagem</p>
          <feather-icon 
            v-if="!activeImageIndex.active" 
            icon="ImageIcon" 
            svgClasses="h-12 w-12" 
            class="image-default-preview"
          >
          </feather-icon>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
        <div class="con-img-upload">
          <div
            v-for="(img,index) in getFilesFilter"
            :class="{
              'fileError':img.error,
              'removeItem':itemRemove.includes(index)
            }"
            :key="index"
            :style="{ width: limit !== 1 || isInternalChatMessage ? '8rem' : '', height: limit !== 1 ? '8rem' : '' }"
            class="img-upload">
            <button
              class="btn-x-file"
              type="button"
              @click="removeFile(index)">
              <i
                translate="no"
                class="material-icons notranslate">
                clear
              </i>
            </button>
            <button
              v-if="showUploadButton"
              :class="{
                'on-progress': img.percent,
                'ready-progress': img.percent >= 100
              }"
              :style="{
                height: `${img.percent}%`
              }"
              class="btn-upload-file"
              @click="upload(index)">
              <i
                translate="no"
                class="material-icons notranslate">
                {{ img.percent >= 100?img.error?'report_problem':'cloud_done':'cloud_upload' }}
              </i>
              <span>{{ img.percent }} %</span>
            </button>
            <img
              v-if="img.src"
              :style="{
                maxWidth:img.orientation == 'h'?'100%':'none',
                maxHeight:img.orientation == 'w'?'100%':'none'
              }"
              :key="index"
              :src="img.src"
              @touchend="viewImage(img.src,$event)"
              @dblclick="viewImage(img.src,$event)"
              @click="setActiveImageIndex(index, img.src, img.name)">
              <h4
                v-if="!img.src"
                class="text-archive"
                :key="index"
                @click="setActiveImageIndex(index, img.src, img.name)">
                <i
                translate="no"
                  class="material-icons notranslate">
                  description
                </i>
              <span>
                {{ img.name }}
              </span>
              {{  index }}
            </h4>
          </div>
          
          <div
            v-if="(srcs.length - itemRemove.length) < Number(limit)"
            :class="{
              'on-progress-all-upload': percent != 0,
              'is-ready-all-upload': percent >= 100,
              'disabled-upload': $attrs.hasOwnProperty('disabled')
                || limit ? (srcs.length - itemRemove.length) >= Number(limit) : false
            }"
            class="con-input-upload">
            <input
              ref="fileInput"
              v-bind="$attrs"
              :multiple="multiple"
              :disabled="$attrs.disabled || limit?(srcs.length - itemRemove.length) >= Number(limit):false"
              type="file"
              @change="getFiles">
            <span class="text-input">
              {{ text }}
            </span>
            <span
              :style="{
                width:`${percent}%`
              }"
              class="input-progress">

            </span>
            <button
              v-if="showUploadButton"
              :disabled="filesx.length == 0"
              type="button"
              title="Upload"
              class="btn-upload-all vs-upload--button-upload"
              @click="upload('all')">
              <i
                translate="no"
                class="material-icons notranslate">
                cloud_upload
              </i>
            </button>
            
          </div>
        </div>
      </vs-col>
      <div v-if="activeImageIndex.active" style="display: flex;">
        <vs-input
          class="vs-upload--input-caption" 
          v-model="itemsLoaded[getFilesPreview].caption" 
          ref="input"
          placeholder="Digite aqui sua legenda"
          style="align-items: flex-end;"
        />
        <VsDropdown vs-collapse vs-trigger-click style="cursor: pointer">
          <feather-icon
              icon="SmileIcon"
              svgClasses="h-7 w-7 mt-1 mb-10"
              class="btn-drop ml-2 cursor-pointer"
          />

          <VsDropdownMenu>
            <div>
              <picker 
                title=""
                set="apple"
                color="#42acff"
                emoji="raised_hand"
                locale="br"
                :perLine="11"
                @select="selectEmoji"
                :i18n="i18n"
                :infiniteScroll=false
              />
            </div>
          </VsDropdownMenu>
        </VsDropdown>
      </div>
      
    </vs-row>

    <div class="con-img-upload" v-else>
      <div
        v-for="(img,index) in getFilesFilter"
        :class="{
          'fileError':img.error,
          'removeItem':itemRemove.includes(index)
        }"
        :key="index"
        class="img-upload">
        <button
          class="btn-x-file"
          type="button"
          @click="removeFile(index)">
          <i
            translate="no"
            class="material-icons notranslate">
            clear
          </i>
        </button>
        <button
          v-if="showUploadButton"
          :class="{
            'on-progress': img.percent,
            'ready-progress': img.percent >= 100
          }"
          :style="{
            height: `${img.percent}%`
          }"
          class="btn-upload-file"
          @click="upload(index)">
          <i
            translate="no"
            class="material-icons notranslate">
            {{ img.percent >= 100?img.error?'report_problem':'cloud_done':'cloud_upload' }}
          </i>
          <span>{{ img.percent }} %</span>
        </button>
        <img
          v-if="img.src"
          :style="{
            maxWidth:img.orientation == 'h'?'100%':'none',
            maxHeight:img.orientation == 'w'?'100%':'none'
          }"
          :key="index"
          :src="img.src"
          @touchend="viewImage(img.src,$event)"
          @click="viewImage(img.src,$event)">
        <h4
          v-if="!img.src"
          class="text-archive">
          <i
            translate="no"
            class="material-icons notranslate">
            description
          </i>
          <span>
            {{ img.name }}
          </span>
        </h4>
      </div>
      <div
        v-if="(srcs.length - itemRemove.length) < Number(limit)"
        :class="{
          'on-progress-all-upload': percent != 0,
          'is-ready-all-upload': percent >= 100,
          'disabled-upload': $attrs.hasOwnProperty('disabled')
            || limit ? (srcs.length - itemRemove.length) >= Number(limit) : false
        }"
        class="con-input-upload">
        <input
          ref="fileInput"
          v-bind="$attrs"
          :multiple="multiple"
          :disabled="$attrs.disabled || limit?(srcs.length - itemRemove.length) >= Number(limit):false"
          type="file"
          @change="getFiles">
        <span class="text-input">
          {{ text }}
        </span>
        <span
          :style="{
            width:`${percent}%`
          }"
          class="input-progress">

        </span>
        <button
          v-if="showUploadButton"
          :disabled="filesx.length == 0"
          type="button"
          title="Upload"
          class="btn-upload-all vs-upload--button-upload"
          @click="upload('all')">
          <i
            translate="no"
            class="material-icons notranslate">
            cloud_upload
          </i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import viewUpload from './ViewUpload'
  import axios from 'axios'
  import { Picker } from 'emoji-mart-vue'

  const i18n = {
  search: 'Buscar',
  notfound: 'Nenhum resultado encontrado',
  categories: { 
    search: 'Resultados de pesquisa', 
    recent: 'Usados frequentemente',
    people: 'Smileys e Pessoas',
    nature: 'Animais e Natureza',
    foods: 'Comidas e Bebidas',
    activity: 'Atividades',
    places: 'Viagens e lugares',
    objects: 'Objetos',
    symbols: 'Símbolos',
    flags: 'Bandeiras',
  },
}

  var lastTap = 0;
  export default {
    name: 'VsUpload',
    components:{
      viewUpload,
      Picker
    },
    inheritAttrs:false,
    props:{
      fileName:{
        default:null,
        type:String
      },
      text:{
        default:'Upload File',
        type:String
      },
      textMax:{
        default:'Maximum of files reached',
        type:String
      },
      limit:{
        default:null,
        type:[Number,String]
      },
      action:{
        default:null,
        type:String
      },
      headers:{
        default:null,
        type:Object
      },
      data: {
        default: null,
        type: Object
      },
      automatic:{
        default: false,
        type: Boolean
      },
      multiple:{
        default: false,
        type: Boolean
      },
      showUploadButton: {
        default: true,
        type: Boolean
      },
      singleUpload: {
        default: false,
        type: Boolean
      },
      maxSize:{
        default: 10,
        type: Number
      },
      isInternalChatMessage: {
        default: false,
        type: Boolean
      }
    },
    data:()=>({
      inputValue: null,
      type: null,
      srcs: [],
      filesx: [],
      itemRemove: [],
      itemsLoaded: [],
      percent: 0,
      viewActive: false,
      viewSrc: null,
      viewUploadx: false,
      i18n: i18n,
      activeImageIndex: {
        name: '',
        url: '',
        index: 0,
        active: false
      },
      oldValueCaption: null
    }),
    computed:{
      getFilesFilter() {
        let files = this.srcs.filter((item) => {
          return !item.remove
        })
        return files
      },
      postFiles(){
        let postFiles = Array.prototype.slice.call(this.filesx);
        postFiles = postFiles.filter((item)=>{
          return !item.hasOwnProperty('remove')
        })
        return postFiles.length
      },
      getFilesPreview() {
        let previewItem = this.itemsLoaded.findIndex(item => item.name === this.activeImageIndex.name);
        if (previewItem !== -1) {
          return previewItem;
        }
        return null;
      },
      isIosDevice() {
        const appleDevice = /iPhone|iPad|iPod|Mobile Safari|safari/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent);
        if (appleDevice){
          return true;
        }
          return false;
        }
    },
    watch:{
      percent(){
        if(this.percent >= 100) {
          this.srcs.forEach((file)=>{
            file.percent = 100
          })
          setTimeout(()=>{
            this.percent = 0
          },1000)
        }
      },
      typedMessage(val){
        if (!val){
          return
        }
      },
      itemsLoaded: {
      handler(newValue, oldValue) {
        let noValueObserver = null;
        if (this.oldValueCaption){
          noValueObserver = this.oldValueCaption
        } else {
          noValueObserver = JSON.parse(JSON.stringify(oldValue))
        }
        this.$nextTick(() => {
          for (let i = 0; i < newValue.length; i++) {
            const newItem = newValue[i];
            const oldItem = noValueObserver[i];
            if (JSON.stringify(newItem) !== JSON.stringify(oldItem)) {
              this.$emit('change-caption', {
                  data: this.itemsLoaded
              });
              return;
            }
          }
        });
        this.oldValueCaption = JSON.parse(JSON.stringify(oldValue));
      },
      deep: true
    }
  },
    methods:{
      viewImage(src,evt){
        var timeout;
        var eventx = (('ontouchstart' in window)
          || (window.DocumentTouch && document instanceof window.DocumentTouch))
            ? 'touchstart'
            : 'click';
        if(eventx == 'click'){
          this.viewActive = true
          this.viewSrc = src
        } else {
          if(evt.type == 'touchend'){
            var currentTime = new Date().getTime();
            var tapLength = currentTime - lastTap;
            clearTimeout(timeout);
            if (tapLength < 500 && tapLength > 0) {
              this.viewActive = true
              this.viewSrc = src
              event.preventDefault();
            }
            lastTap = currentTime;
          }
        }
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      removeFile(index, removeAll = false, forceRemove = false) {
        return new Promise(async (resolve) => {
          if (this.filesx.length || forceRemove) {
            if (removeAll) {
              this.srcs = [];
              this.filesx = [];
              this.itemRemove = [];
              this.itemsLoaded = [];
              this.activeImageIndex = {
                name: '',
                url: '',
                index: 0,
                active: false
              }
              this.$emit('on-delete', { method: 'all' });
              this.viewUploadx = false;
              resolve(true);
            } else {
              this.itemRemove.push(index);
              await this.sleep(400);

              const filesXIdx    = this.filesx.findIndex((c) => c.name === this.srcs[index].name);
              const itemsLoadIdx = this.itemsLoaded.findIndex((c) => c.name === this.srcs[index].name);

              if (this.srcs && this.srcs[index]) {
                this.$emit('on-delete', {
                  method: 'number',
                  file: JSON.parse(JSON.stringify(this.srcs[index]))
                });
              }

              if ( itemsLoadIdx !== -1 ) {
                this.itemsLoaded.splice(itemsLoadIdx, 1);
              }

              if ( filesXIdx !== -1 ) {
                this.filesx.splice(filesXIdx, 1);
              }

              if  (this.itemRemove.length === this.srcs.length) {
                this.viewUploadx = false;
              }

              this.activeImageIndex.active = false;
              resolve(true);
            }
          } else {
            resolve(true);
          }
        })
      },
      getFiles(e,eventPaste=false) {
        this.$emit('update:vsFile', e.target.value)
        let _this     = this
        let fileNamex = []
        let countx    = 0

        function uploadImage(e) {
          let orientation = 'h'
          var image = new Image();
          image.src = e.target.result;
          image.onload = function() {
            if(this.width > this.height){
              orientation = 'w'
            }
            switchImage(this,orientation);
          }
        }
        function switchImage(image,orientation) {
          _this.srcs.push({
            src:image.src,
            name: fileNamex[countx],
            orientation:orientation,
            type:_this.typex,
            percent:null,
            error:false,
            remove:null
          })
          countx++
        }
        var files = e.target.files;
        let count = (this.srcs.length - this.itemRemove.length)
        for (const file in files) {
          if (files.hasOwnProperty(file)) {
            var reader  = new FileReader();
            const filex = files[file];

            this.itemsLoaded = this.itemsLoaded.filter((c) => c.name !== filex.name);
            const exist = this.itemsLoaded.findIndex((c) => c.name === filex.name)

            if ( exist !== -1 ) {
              this.$emit('on-error', {
                data: {
                  message: `O arquivo ${filex.name} já foi carregado.`,
                  time: 7000
                }
              });
              break
            } else if (filex.size > (this.maxSize * 1000000)) {
              this.$emit('on-error', {
                data: {
                  message: `O arquivo ${filex.name} não pode ser maior que ${this.maxSize}mb`,
                  time: 7000
                }
              });
              break
            } else if (this.limit) {
              count ++
              if( count > Number(this.limit) ) {
                break
              }
            }

            if (/image.*/.test(filex.type)) {
              this.typex = 'image'
              fileNamex.push(filex.name)
              this.filesx.push(filex)
              reader.onload = uploadImage;
              reader.readAsDataURL(filex);
            } else if (/video.*/.test(filex.type)) {
              this.typex = 'video'
              this.filesx.push(filex)
              _this.srcs.push({
                src:null,
                name:filex.name,
                type:'video',
                percent:null,
                error:false,
                remove:null
              })
            } else {
              this.filesx.push(filex)
              _this.srcs.push({
                src:null,
                name:filex.name,
                percent:null,
                error:false,
                remove:null
              })
            }
            this.$emit('change', e.target.value, this.filesx)
          }
        }
        
        if(!eventPaste){          
          const input = this.$refs.fileInput
          input.type = 'text'
          input.type = 'file'
        }        
        if (this.automatic) {
          this.upload('all')
        }
      },
      upload(index) {
        this.viewUploadx = true
        const formData = new FormData();
        let postFiles = Array.prototype.slice.call(this.filesx);
        this.$vs.loading({
          type: 'point',
          text: 'Carregando seu arquivo...'
        });

        setTimeout( () => { this.$vs.loading.close() }, 5000);
        if (typeof index == 'number') {
          postFiles = [postFiles[index]]
        } else if (index == 'all') {
          postFiles = postFiles.filter((item) => {
            return !item.hasOwnProperty('remove');
          })
          this.viewUploadx = false;
        }
        const data = this.data || {};
        for (var key in data) {
          formData.append(key, data[key]);
        }
        if (this.singleUpload) {
          postFiles.forEach((filex)=>{
            const formData = new FormData();
            for (var key in data) {
              formData.append(key, data[key]);
            }
            formData.append(this.fileName, filex, filex.name)
            this.uploadx(index, formData)
          })
        } else {
          postFiles.forEach((filex)=>{
            formData.append(this.fileName, filex, filex.name)
          })
          this.uploadx(index, formData)
        }
      },
      uploadx(index, formData) {
        let self          = this
        self.$emit('on-upload-start')
        this.viewUploadx = true

        const headers = this.headers || {};
        headers['Content-Type'] = `multipart/form-data; boundary=${formData._boundary}`
        axios.post(this.action, formData, {
          headers,
          onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            if (percentCompleted < 100) {
              if (typeof index == 'number') {
                self.srcs[index].percent = percentCompleted
              } else {
                self.percent = percentCompleted
              }
            }
          },
          onDownloadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            if (typeof index == 'number') {
              self.srcs[index].percent = percentCompleted
            } else {
              self.percent = percentCompleted
            }
          }
        })
        .then((response) => {
          response.srcs = this.srcs;

          if ( this.multiple && this.automatic && this.singleUpload ) {
            let data        = formData.get('file');
            const itemIndex = this.itemsLoaded.findIndex((c) => c.name === data.name);

            if ( itemIndex !== -1 ) {
              const filteredItemsSrcs = response.srcs.filter(
                (item, index) => !this.itemRemove.includes(index)
              );
              const filteredItemsLoaded = this.itemsLoaded.filter(
                itemLoaded => {
                  return filteredItemsSrcs.some(
                    itemSrc => {
                      return itemSrc.name === itemLoaded.name;
                    }
                  );
                }
              );

              response.data = filteredItemsLoaded;
              this.$emit('change-caption', response);

              this.$vs.loading.close();
              return self.$emit('on-success', response);
            }

            this.itemsLoaded.push({
              name: data.name,
              url: response.data.fileUrl,
              caption: ''
            });

            if (
              this.itemsLoaded.length === (this.srcs.length - this.itemRemove.length)
            ) {
              response.data = this.itemsLoaded
              this.$emit('change-caption', response);
              this.$vs.loading.close();
              return self.$emit('on-success', response);
            }
          } else {
            this.$emit('change-caption', response);
            this.$vs.loading.close();
            return self.$emit('on-success', response);
          }

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          self.$emit('on-error',error);
          if (typeof index == 'number') {
            self.srcs[index].error = true;
          }
        });
      },
      selectEmoji(emoji) {
        const index = this.getFilesPreview;

        if (index !== undefined && this.itemsLoaded.hasOwnProperty(index)) {
          const caption = this.itemsLoaded[index].caption || ''; 
          const updatedCaption = caption + emoji.native; 
          this.$set(this.itemsLoaded[index], 'caption', updatedCaption);
        }
      },
      setActiveImageIndex(index, url, name) {
        this.activeImageIndex.name = name;
        this.activeImageIndex.url = url;
        this.activeImageIndex.index = index;
        this.activeImageIndex.active = true;
      },
    },
  }
</script>

<style lang="scss">
 .vs-upload--input-caption{
   width: 60%;
   display: flex;
   margin-left: 13rem;
   margin-bottom: 2.2rem;
   text-align: start;
 }

 .vs-upload--img-src{
   width: 50%;
   display: flex;
   margin-inline: 3rem;
   text-align: center;
 }

 .image-default-preview{
    transform: translateX(-1em);
    display: flex;
    margin-top: 2rem;
    margin-left: 15rem;

  }

</style>